import styled from "styled-components";
import { getColor } from "../themeHandler";

interface ModalContentProps {
  readonly modalTheme: string;
  readonly isContentBold?: boolean;
}

export const StyledContent = styled.div<ModalContentProps>`
  max-width: 100%;
  text-align: center;
  color: ${(props) => getColor(props.modalTheme, 'contentTextColor')};
  font-weight: ${(props) => (props.isContentBold ? 700 : 400)};
`;

StyledContent.defaultProps = {};
